import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from '../components/Loading/Loading';

const Main: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <Loading size="lg" text="Загрузка..." />;
  }

  if (isAuthenticated) {
    return <Navigate to="/app" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default Main;
